import { Button, Flex, Text, Box, useColorModeValue } from '@chakra-ui/react'
import { FC, useMemo } from 'react'

interface IGridQuantity {
  data?: any[]
  isLoading?: boolean
  disabled?: boolean
  textButton?: string
  onClick?: () => void
}

const GridQuantityAlertPurchase: FC<IGridQuantity> = ({
  data = [],
  isLoading,
  disabled,
  textButton,
  onClick
}) => {
  const bgColor = useColorModeValue('white', 'gray.800')
  const borderColor = useColorModeValue('gray.300', 'gray.600')
  const textColor = useColorModeValue('gray.700', 'gray.100')

  const { protocolos, pedidos, produtos } = useMemo(() => {
    const protocolos = new Set<string>()
    const pedidos = new Set<string>()
    const produtos = new Set<string>()

    data.forEach(item => {
      if (item['info-id']) protocolos.add(item['info-id'])
      if (item['info-pedido']) pedidos.add(item['info-pedido'])
      if (item['produto-id']) produtos.add(item['produto-id'])
    })

    return {
      protocolos: protocolos.size,
      pedidos: pedidos.size,
      produtos: produtos.size
    }
  }, [data])

  return (
    <Flex
      justifyContent="space-between"
      alignItems="center"
      // bg={bgColor}
      px={5}
      py={3}
      // borderRadius="md"
      // border="1px solid"
      // borderColor={borderColor}
      boxShadow="sm"
      mb={4}
      flexWrap="wrap"
    >
      <Box>
        <Text fontSize="sm" color="gray.500" mb={1}>
          Resumo da consulta:
        </Text>
        <Text fontSize="md" fontWeight="bold" color="black">
          {protocolos} protocolo{protocolos !== 1 ? 's' : ''}, {pedidos} pedido
          {pedidos !== 1 ? 's' : ''}, {produtos} produto
          {produtos !== 1 ? 's' : ''}
        </Text>
      </Box>

      {textButton && (
        <Button
          fontSize="sm"
          size="sm"
          colorScheme="green"
          variant="outline"
          isLoading={isLoading}
          isDisabled={disabled}
          onClick={onClick}
          borderRadius="md"
          mt={[3, 0]}
        >
          {textButton}
        </Button>
      )}
    </Flex>
  )
}

export default GridQuantityAlertPurchase
